import request from '../utils/request'

//个人信息
export function personalDetails() {
    return request.post('/api/user_info')
}
//个人认证
export function certification() {
    return request.post('/api/psn_auth_url')
}
//修改个人信息
export function modifyInformation(gender, email, nation, address, sheng_code) {
    return request.post('/api/upd_user_info', { "gender": gender, "email": email, "nation": nation, "address": address, "sheng_code": sheng_code })
}
//企业认证
export function enterpriseName(orgName, address) {
    return request.post('/api/org_auth_url', { 'orgName': orgName, "address": address })
}
//企业信息展示
export function enterpriseInformation() {
    return request.post('/api/company_info')
}
//消息列表
export function messageList(limit, page) {
    return request.post('/api/sys_msg_list', { "limit": limit, "page": page })
}
//已读未读
export function readUnread(req_type, msg_id) {
    return request.post('/api/sys_msg_upd_read', { "req_type": req_type, "msg_id": msg_id })
}
//个人认证是否过期
export function individualExpire() {
    return request.post('/api/psn_repeat_auth_url')
}
//企业认证是否过期
export function enterpriseExpire() {
    return request.post('/api/org_repeat_auth_url')
}
//加入企业
export function joinCompany(orgName) {
    return request.post('/api/add_org_members', { "orgName": orgName })
}
//（新）会员信息
export function membership() {
    return request.post('/api/user_identity')
}
//修改企业信息
export function modifyEnterprise(company_address, email, sheng_code) {
    return request.post('/api/upd_com_info', { "company_address": company_address, "email": email, "sheng_code": sheng_code })
}
//员工列表
export function staffList(limit, page) {
    return request.post('/api/com_yg_list', { "limit": limit, "page": page })
}
//获取员工验证码
export function verificationCode(mobile) {
    return request.post('/api/send_yg_sms_code', { "mobile": mobile })
}
//添加员工
export function addStaff(name, mobile, captcha, status) {
    return request.post('/api/add_com_yuangong', { "name": name, "mobile": mobile, "captcha": captcha, "status": status })
}
//编辑员工状态
export function editStatus(link_id, name, status) {
    return request.post('/api/edit_com_yuangong', { "link_id": link_id, "name": name, "status": status })
}
//切换身份
export function switchIdentity() {
    return request.get('/api/upd_user_identity')
}
//消息详情
export function messageData(msg_id) {
    return request.post('/api/sys_msg_detail', { "msg_id": msg_id })
}
//其他平台免登陆
export function noLanding(zcdb_token) {
    return request.post('/api/mian_login', { "zcdb_token": zcdb_token })
}
//获取省份
export function getProvinces() {
    return request({
        url: '/api/get_sheng_list',
        method: 'post',
    })
}
//个人认证完毕后提醒创建企业
export function warnIndividual(data) {
    return request({
        url: '/api/after_auth_com_remind',
        method: 'post',
        data
    })
}
//账单管理列表
export function billList(data) {
    return request({
        url: '/api/com_zhangdan_list',
        method: 'post',
        data
    })
}
//坐席管理列表
export function getSeatsList(data) {
    return request({
        url: '/api/com_zuoxi_list',
        method: 'post',
        data
    })
}
//查看坐席有效期限列表
export function viewPeriodList(data) {
    return request({
        url: '/api/com_zuoxi_youxiao_list',
        method: 'post',
        data
    })
}
//计费记录列表
export function billingRecordList(data) {
    return request({
        url: '/api/com_jifei_list',
        method: 'post',
        data
    })
}
//充值记录列表
export function rechargeRecordList(data) {
    return request({
        url: '/api/com_chongzhi_list',
        method: 'post',
        data
    })
}
//退费记录列表
export function refundRecordList(data) {
    return request({
        url: '/api/com_tuifei_list',
        method: 'post',
        data
    })
}
//计费记录
export function billingRecordList_gr(data) {
    return request({
        url: '/api/user_jifei_list',
        method: 'post',
        data
    })
}
//充值记录
export function rechargeRecordList_gr(data) {
    return request({
        url: '/api/user_chongzhi_list',
        method: 'post',
        data
    })
}
//退费记录
export function refundRecordList_gr(data) {
    return request({
        url: '/api/user_tuifei_list',
        method: 'post',
        data
    })
}
// 导出计费记录
export function exportBillingRecord(data) {
    return request({
        url: '/api/export_com_jifei_list',
        method: 'post',
        data
    })
}